import api from "!../../../../../../releases/0ec698dda5253e40cf134cec0d2d2d3d11ae13cc/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/0ec698dda5253e40cf134cec0d2d2d3d11ae13cc/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/0ec698dda5253e40cf134cec0d2d2d3d11ae13cc/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/0ec698dda5253e40cf134cec0d2d2d3d11ae13cc/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};